import plans,{ AllPlans } from '@/plans';
import { mapGetters } from 'vuex';

export const defFilter = (list, filterKeys = []) => {
    return filterKeys.filter(Boolean).map(key => {
        const keys = key.split('$');
        const key0 = keys[0];
        // priority: ZOOM_MEETING$BIZ_PLUS fallback to ZOOM_MEETING
        return list.find(x => x.key === key) || list.find(x => x.key === key0);
    }).filter(Boolean);
};

export default {
    props: {
        filter: {
            type: Function,
            default: defFilter,
        },
        filterKeys: {
            type: Array,
            default: () => [],
        },
        configPlanTileStatus: {
            type: Object,
            default: () => ({}),
        }
    },
    computed:{
      ...mapGetters(['pastPlans']),
    },
    render(h) {
        const filter = window.__hook_plans_filter__ || this.filter;
      let orderPlans = plans;
      if (this.pastPlans?.length > 0) {
        orderPlans = AllPlans;
      }
        return h(
            'div',
            {},
            filter(orderPlans, this.filterKeys).map(x => h(x.components?.config, {
                key: x.key,
                props: {
                    configPlanTileStatus: this.configPlanTileStatus,
                    isAddon: !!x.components?.addon,
                },
                on: {
                    ...this.$listeners
                }
            })),
        );
    },
};
